import { Component, Vue, Watch } from 'vue-property-decorator'
import { queryTeacherAdmin } from '@/api'
import HighFilter from '@/components/highFilter/index.vue'
@Component({ name: 'MainList', components: { HighFilter } })
export default class MainList extends Vue {
  private tableData: any = []
  private teacherName: any =''
  private pageType: any = 1
  private fileList: any =[]
  private currentPage: any = 1
  private filterData: any =[]
  private filterResult: any = {}
  private totalPage: any = 1
  private totalNum: any = 1
  private tableloading: any = false
  private showHighFilter: any = false
  created () {
    this.tableData = []
    this.pageType = this.$route.meta.type
    this.initPageData()
  }

  activated () {
    // 只刷新数据，不改变整体的缓存
    this.initPageData()
  }

  private async initPageData () {
    this.tableloading = true
    const param: any = { page: this.currentPage, name: this.teacherName, limit: 20 }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    const result: any = await queryTeacherAdmin(param)
    this.filterData = result.search
    const { allPage, currentPage, allNumber, teacherList } = result
    this.tableData = teacherList
    this.totalPage = allPage
    this.totalNum = allNumber
    this.currentPage = currentPage
    this.tableloading = false
  }

  private async onPageChange () {
    this.initPageData()
  }

  // 批量导入
  private async handleRemove (file: any, fileList: any) {
    console.log(file, fileList)
  }

  private async handlePreview (file: any) {
    console.log(file)
  }

  private async handleExceed (files: string | any[], fileList: string | any[]) {
    this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
  }

  // 批量导入删除
  private async beforeRemove (file: { name: any }, fileList: any) {
    return this.$confirm(`确定移除 ${file.name}？`)
  }

  // 表格修改/查看详情
  private ediLookDetailRow (row: any, type: any) {
    this.$router.push({ path: 'main_tutor_detail', query: { type: type, id: row.id } })
    // if (this.pageType === 1) { // 主导师
    //   // type 1.修改 2.查看详情 3.新增
    //   this.$router.push({ path: 'main_tutor_detail', query: { type: type, id: row.id } })
    // } else { // 其他导师
    //   this.$router.push({ path: 'tutor_detail', query: { type: type, id: row.id, pageType: this.pageType } })
    // }
  }

  private addTeacher (type: any) {
    this.$router.push({ path: 'main_tutor_detail', query: { type: type } })
    // if (this.pageType === 1) { // 主导师
    //   // type 3.新增
    //   this.$router.push({ path: 'main_tutor_detail', query: { type: type } })
    // } else { // 其他导师
    //   this.$router.push({ path: 'tutor_detail', query: { type: type, pageType: this.pageType } })
    // }
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }
}
